import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke="var(--color-black)" strokeWidth="2">
      <path d="M0 12h24M12 0v24" />
    </g>
  </svg>
);
